import React from 'react';
import PropTypes from 'prop-types';
import { directionMap } from './styles';

export const SvgArrow = ({ width, height, stroke, direction }) => (
  <svg
    width={width || '11px'}
    height={height || '12px'}
    viewBox="0 0 11 12"
    version="1.1"
    style={{ transform: `rotate(${directionMap[direction]}deg)` }}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-271.000000, -2015.000000)" stroke={stroke} strokeWidth="2">
        <g transform="translate(270.000000, 2009.000000)">
          <g transform="translate(-5.000000, 0.000000)">
            <path d="M16.6666667,12 L7.33333333,12" />
            <polyline points="12 16.6666667 7.33333333 12 12 7.33333333" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgArrow.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  direction: PropTypes.string,
};

SvgArrow.defaultProps = {
  stroke: '#000000',
  direction: 'left',
};
